import { useCallback } from 'react';

import { getFeConfigApi, updateFeConfigApi } from './api';

// convSetting 对话页设置
// 历史对话可见项
function useFeConfig(props) {
  const { key } = props;
  const getFeConfig = useCallback(() => {
    return getFeConfigApi({
      keys: [key]
    });
  }, [key]);

  const updateFeConfig = useCallback(
    data => {
      return updateFeConfigApi({
        key: key,
        data
      });
    },
    [key]
  );

  return {
    getFeConfig,
    updateFeConfig
  };
}

export default useFeConfig;
